import React from 'react';
import { func, bool } from 'prop-types';
import { findIndex, noop } from 'lodash';
import { CupMockUp, CardsMockUp, LaptopMockUp, PhonesMockUp } from '@fiverr-private/variations_display';
import { useUserAgentContext } from '../../../../shared/components/UserAgentContext';
import { useChooseVariationContext } from '../Context';
import MainSample from './MainSample';
import './style.scss';

const Samples = ({ onMainSampleTextFieldsRender = noop, onPurchase = noop, isLoading }) => {
    const { allVariations, selectedVariation } = useChooseVariationContext();
    const { isMobile } = useUserAgentContext();

    const variationIndex = findIndex(allVariations, ['id', selectedVariation.id]);

    return (
        <div className="variations-samples">
            <MainSample
                variationIndex={variationIndex}
                onTextFieldsRender={onMainSampleTextFieldsRender}
                isLoading={isLoading}
                onPurchase={onPurchase}
            />
            <div className="cup-mock-up">
                <CupMockUp variation={selectedVariation} isSquare={!isMobile} />
            </div>
            <CardsMockUp variation={selectedVariation} />
            <PhonesMockUp variation={selectedVariation} />
            <LaptopMockUp variation={selectedVariation} />
        </div>
    );
};

Samples.propTypes = {
    onMainSampleTextFieldsRender: func,
    onPurchase: func,
    isLoading: bool,
};

export default Samples;
